import { Z_INDEX_MAX } from '@/helpers/commonConsts'
import { commonUtils } from '@/helpers/commonUtils'
import { ComponentFactory } from '@/mobxTools'
import { FeatureType, userService } from '@/services/userService'
import { Modal, QRCode, Spin, Tooltip } from 'antd'
import classNames from 'classnames'
import { useEffect } from 'react'

import style from './PayVipUpgradeDialog.module.less'
import { PayVipUpgradeDialogVm } from './PayVipUpgradeDialogVm'
import { QuestionCircleOutlined } from '@ant-design/icons'

/** PayQrDialog 组件的 Props */
export type PayVipUpgradeDialogProps = {
  open: boolean
  source?: string
  from?: string
  planUpgrade: PostDataTypes.UpgradePlan
  feature?: FeatureType
  paySuccess?: () => void
  onClose: () => void
}

/**
 * @author TODO
 * (在这里对组件进行说明)
 */
export const PayVipUpgradeDialog = ComponentFactory.createComponent(
  'PayVipUpgradeDialog',
  PayVipUpgradeDialogVm,
  (vm) => {
    const { open, planUpgrade, onClose } = vm.props

    const unitDesc = planUpgrade.upgradeTimeType === 'year' ? '年' : '月'
    const priceBox = () => {
      return (
        <>
          <div className={classNames('flex-row', 'justify-end')}>
            <span className={style.price}>{vm.price || ''}</span>
            <span className={style.unit}>元</span>
          </div>
          <div className={classNames(style.priceDesc)}>
            <span className={style.planPrice}>
              原价{planUpgrade.planPrice}元/{unitDesc}，
              <span className={style.discountDesc}>
                当前会员已抵扣
                {planUpgrade.planPrice - vm.price}元
              </span>
              <Tooltip
                title={
                  <>
                    <p>补差价升级规则：</p>
                    <p>
                      1、一般情况，差价计算：升级所需金额 = 目标会员价格 −
                      当前会员实付金额。（注：若Max年度升级为Ultra年度，则补差价=Ultra年费价格 −
                      Max年费实付金额*剩余月数/12）
                    </p>

                    <p>
                      2、生效时间与周期：升级成功后，新会员权益立即生效。新的会员周期从支付时间开始重新计算，不与原周期叠加。
                    </p>
                    <p>
                      3、额度抵扣机制：升级成功当月，将根据原会员已使用额度（高级模型Token、PDF分段翻译、PDF无损翻译、Word翻译、图片翻译等）进行自动抵扣，避免重复计费。
                    </p>
                    <p>4、降级：已完成的补差价升级不支持降级。</p>
                  </>
                }
              >
                <QuestionCircleOutlined
                  className={style.questionIcon}
                  style={{ fontSize: 13, marginLeft: '5px' }}
                />
              </Tooltip>
            </span>
          </div>
        </>
      )
    }

    return (
      <Modal
        width='572px'
        zIndex={Z_INDEX_MAX}
        getContainer={false}
        maskClosable={false}
        wrapClassName={classNames(style.payVipUpgradeDialog)}
        open={open}
        centered
        footer={false}
        onCancel={() => {
          onClose()
        }}
      >
        <div className={classNames(style.payQrDialogContent)}>
          <p className={classNames(style.title)}>{planUpgrade.desc}</p>

          <div className={classNames(style.channelList)}>
            <div
              className={classNames(style.alipayBox, style.flexRow, {
                [style.active]: vm.currentTabKey === 'alipay_qr',
              })}
              onClick={() => {
                if (vm.currentTabKey === 'alipay_qr') {
                  return
                }
                vm.currentTabKey = 'alipay_qr'
                vm.genOrderQrCode()
              }}
            >
              <img src='https://assets.weibanzhushou.com/web/pt-web/ali-pay.18b4779d8424.png' />
              <span>支付宝支付</span>
            </div>
            <div
              className={classNames(style.wechatBox, style.flexRow, {
                [style.active]: vm.currentTabKey === 'wx_pub_qr',
              })}
              onClick={() => {
                if (vm.currentTabKey === 'wx_pub_qr') {
                  return
                }
                vm.currentTabKey = 'wx_pub_qr'
                vm.genOrderQrCode()
              }}
            >
              <img src='https://assets.weibanzhushou.com/web/pt-web/wechat-pay.9115a8ba339f.png' />
              <span>微信支付</span>
            </div>
          </div>

          <div className={classNames(style.qrBox)}>
            <img
              src='https://assets.weibanzhushou.com/web/pt-web/login-page_bg__qr.518234b9d754.png'
              className={classNames(style.qrBg)}
            />

            {vm.qrErr && (
              <div
                className={classNames(style.reloadBox)}
                onClick={() => {
                  vm.genOrderQrCode()
                }}
              >
                <img
                  className={classNames(style.icon)}
                  src='https://assets.weibanzhushou.com/web/pt-web/icon__qr-reload.b68e5cd3c901.png'
                />
                <span>刷新</span>
              </div>
            )}
            {!vm.qrErr && (
              <Spin spinning={!vm.qrUrl || vm.qrLoading} size='small'>
                {vm.qrUrl && (
                  <QRCode
                    value={vm.qrUrl}
                    size={220}
                    bordered={false}
                    style={{ padding: 0 }}
                  ></QRCode>
                )}
              </Spin>
            )}
          </div>

          <div className={style.priceBox}>{priceBox()}</div>
        </div>
      </Modal>
    )
  }
)
